import { useAPIReducer } from "../reducer/apiReducer";
import Error from "./Error.component";
import InputText from "./InputText.component";
import OnSubmitForm from "./onSubmitForm.component";
import Select from "./Select.component";

const FormComponent = () => {
  const {
    countries,
    subscribeForm,
    updateSubscribeForm,
    options,
    submitSubscribe,
    resetForm,
  } = useAPIReducer();

  const { name, email, country } = subscribeForm;
  const { error, success, onSubmission } = options;

  if (!countries) return <div></div>;
  if (success) {
    return (
      <div className="relative">
        <div className="bg-white h-full rounded-lg py-10">
          <div className="flex flex-col items-center justify-center h-full">
            <img src="/images/success.jpg" alt="" />
            <h2 className="font-bold mt-5 text-lg">{success}</h2>
            <button
              onClick={resetForm}
              className="font-light text-sm  mt-3 text-blue-400 hover:text-blue-500 hover:font-bold transition-all duration-200 px-3 py-2 hover:bg-gray-100 active:bg-blue-400 active:text-white active:shadow-md rounded-md"
            >
              [Close]
            </button>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="relative">
      {error && <Error />}

      <form onSubmit={submitSubscribe}>
        <InputText
          id="name"
          type="text"
          label="Full name"
          value={name}
          onChange={updateSubscribeForm}
        />
        <InputText
          id="email"
          type="email"
          label="Email"
          value={email}
          onChange={updateSubscribeForm}
          required={true}
        />
        <Select
          onChange={updateSubscribeForm}
          value={country}
          countries={countries}
        />

        <button
          type="submit"
          disabled={onSubmission}
          className="bg-indigo-500 w-full  block text-white rounded-md p-5 mt-10 font-bold hover:bg-indigo-600 transition-all duration-300 shadow-lg shadow-slate-300 hover:shadow-indigo-500 hover:shadow-md active:bg-indigo-500 active:shadow-md"
        >
          Submit
        </button>
      </form>
      {onSubmission && <OnSubmitForm />}
    </div>
  );
};

export default FormComponent;
